import request from './index'

export const getCarLocationMapApi= carId=>{
    return request({
        url:'getCarLocationMap/'+carId,
        method:'get'
    })
}

export const canvasPic=(carId)=>{
    return request({
        url: '/file/canvasPic',
        method: 'post',
        data:{
            command_id:41,
            carId:carId
        }
    })
}

export const imgUrl=(flag,carId,fileName)=>{
    return request({
        url: '/file/filePreview',
        method: 'post',
        responseType: 'blob',
        data: {
            command_id:52,
            flag:flag,
            carId:carId,
            fileName:fileName
        }
    }).then(res=>{
        let url=window.URL.createObjectURL(new Blob([res]))
        return url
    })
}